module.exports = {
	"contractName": "StrongBoxFactory",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				},
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "102:399:23:-;;;501:5:29;:18;;-1:-1:-1;;;;;;501:18:29;509:10;501:18;;;102:399:23;;;;;;",
	"deployedSourceMap": "102:399:23:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;141:179;;-1:-1:-1;;;;;141:179:23;;;;;;;;;-1:-1:-1;;;;;141:179:23;;;;;;;;;;;;;;238:20:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:29;;;;324:175:23;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;324:175:23;-1:-1:-1;;;;;324:175:23;;;;;;;;;;;;;;;;;;;;;;;;;;;;832:169:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;832:169:29;-1:-1:-1;;;;;832:169:29;;;;;;;141:179:23;206:7;234:11;265:12;248:11;;:::i;:::-;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;248:11:23;234:25;;294:5;280:20;;:::i;:::-;-1:-1:-1;;;;;280:20:23;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;-1:-1;265:35:23;141:179;-1:-1:-1;;;;141:179:23:o;238:20:29:-;;;-1:-1:-1;;;;;238:20:29;;:::o;324:175:23:-;410:4;437:12;462:9;437:35;;485:2;-1:-1:-1;;;;;485:7:23;;:9;;;;;;;;;;;;;;;;;;;;;;;8::-1;5:2;;;30:1;27;20:12;5:2;485:9:23;;;;8::-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;485:9:23;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;485:9:23;;324:175;-1:-1:-1;;;;324:175:23:o;832:169:29:-;653:5;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;908:22:29;;;;900:31;;;;;;958:5;;;937:37;;-1:-1:-1;;;;;937:37:29;;;;958:5;;;937:37;;;980:5;:16;;-1:-1:-1;;980:16:29;-1:-1:-1;;;;;980:16:29;;;;;;;;;;832:169::o;102:399:23:-;;;;;;;;;;:::o;:::-;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.24;\n\nimport \"./base/Level.sol\";\nimport \"./StrongBox.sol\";\nimport \"./Guard.sol\";\n\ncontract StrongBoxFactory is Level {\n  function createInstance(address _player) public payable returns (address) {\n    _player;\n    Guard guard = new Guard();\n    StrongBox sb = new StrongBox(guard);\n    return sb;\n  }\n\n  function validateInstance(address _instance, address _player)\n    public\n    returns (bool)\n  {\n    _player;\n    StrongBox sb = StrongBox(_instance);\n    return sb.pass();\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/StrongBoxFactory.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/StrongBoxFactory.sol",
		"exportedSymbols": {
			"StrongBoxFactory": [
				2198
			]
		},
		"id": 2199,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2145,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:23"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 2146,
				"nodeType": "ImportDirective",
				"scope": 2199,
				"sourceUnit": 2867,
				"src": "26:26:23",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/StrongBox.sol",
				"file": "./StrongBox.sol",
				"id": 2147,
				"nodeType": "ImportDirective",
				"scope": 2199,
				"sourceUnit": 2144,
				"src": "53:25:23",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Guard.sol",
				"file": "./Guard.sol",
				"id": 2148,
				"nodeType": "ImportDirective",
				"scope": 2199,
				"sourceUnit": 1717,
				"src": "79:21:23",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 2149,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "131:5:23",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 2150,
						"nodeType": "InheritanceSpecifier",
						"src": "131:5:23"
					}
				],
				"contractDependencies": [
					1716,
					2143,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2198,
				"linearizedBaseContracts": [
					2198,
					2866,
					2922
				],
				"name": "StrongBoxFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 2174,
							"nodeType": "Block",
							"src": "215:105:23",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2157,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2152,
										"src": "221:7:23",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2158,
									"nodeType": "ExpressionStatement",
									"src": "221:7:23"
								},
								{
									"assignments": [
										2160
									],
									"declarations": [
										{
											"constant": false,
											"id": 2160,
											"name": "guard",
											"nodeType": "VariableDeclaration",
											"scope": 2175,
											"src": "234:11:23",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Guard_$1716",
												"typeString": "contract Guard"
											},
											"typeName": {
												"contractScope": null,
												"id": 2159,
												"name": "Guard",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1716,
												"src": "234:5:23",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Guard_$1716",
													"typeString": "contract Guard"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2164,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 2162,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "248:9:23",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$__$returns$_t_contract$_Guard_$1716_$",
												"typeString": "function () returns (contract Guard)"
											},
											"typeName": {
												"contractScope": null,
												"id": 2161,
												"name": "Guard",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1716,
												"src": "252:5:23",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Guard_$1716",
													"typeString": "contract Guard"
												}
											}
										},
										"id": 2163,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "248:11:23",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Guard_$1716",
											"typeString": "contract Guard"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "234:25:23"
								},
								{
									"assignments": [
										2166
									],
									"declarations": [
										{
											"constant": false,
											"id": 2166,
											"name": "sb",
											"nodeType": "VariableDeclaration",
											"scope": 2175,
											"src": "265:12:23",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_StrongBox_$2143",
												"typeString": "contract StrongBox"
											},
											"typeName": {
												"contractScope": null,
												"id": 2165,
												"name": "StrongBox",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2143,
												"src": "265:9:23",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_StrongBox_$2143",
													"typeString": "contract StrongBox"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2171,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2169,
												"name": "guard",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2160,
												"src": "294:5:23",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Guard_$1716",
													"typeString": "contract Guard"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_contract$_Guard_$1716",
													"typeString": "contract Guard"
												}
											],
											"id": 2168,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "280:13:23",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$_t_address_$returns$_t_contract$_StrongBox_$2143_$",
												"typeString": "function (address) returns (contract StrongBox)"
											},
											"typeName": {
												"contractScope": null,
												"id": 2167,
												"name": "StrongBox",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2143,
												"src": "284:9:23",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_StrongBox_$2143",
													"typeString": "contract StrongBox"
												}
											}
										},
										"id": 2170,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "280:20:23",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_StrongBox_$2143",
											"typeString": "contract StrongBox"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "265:35:23"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2172,
										"name": "sb",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2166,
										"src": "313:2:23",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_StrongBox_$2143",
											"typeString": "contract StrongBox"
										}
									},
									"functionReturnParameters": 2156,
									"id": 2173,
									"nodeType": "Return",
									"src": "306:9:23"
								}
							]
						},
						"documentation": null,
						"id": 2175,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2153,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2152,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2175,
									"src": "165:15:23",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2151,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "165:7:23",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "164:17:23"
						},
						"payable": true,
						"returnParameters": {
							"id": 2156,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2155,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2175,
									"src": "206:7:23",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2154,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "206:7:23",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "205:9:23"
						},
						"scope": 2198,
						"src": "141:179:23",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2196,
							"nodeType": "Block",
							"src": "418:81:23",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2184,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2179,
										"src": "424:7:23",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2185,
									"nodeType": "ExpressionStatement",
									"src": "424:7:23"
								},
								{
									"assignments": [
										2187
									],
									"declarations": [
										{
											"constant": false,
											"id": 2187,
											"name": "sb",
											"nodeType": "VariableDeclaration",
											"scope": 2197,
											"src": "437:12:23",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_StrongBox_$2143",
												"typeString": "contract StrongBox"
											},
											"typeName": {
												"contractScope": null,
												"id": 2186,
												"name": "StrongBox",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2143,
												"src": "437:9:23",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_StrongBox_$2143",
													"typeString": "contract StrongBox"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2191,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2189,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2177,
												"src": "462:9:23",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 2188,
											"name": "StrongBox",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2143,
											"src": "452:9:23",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_StrongBox_$2143_$",
												"typeString": "type(contract StrongBox)"
											}
										},
										"id": 2190,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "452:20:23",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_StrongBox_$2143",
											"typeString": "contract StrongBox"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "437:35:23"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"id": 2192,
												"name": "sb",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2187,
												"src": "485:2:23",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_StrongBox_$2143",
													"typeString": "contract StrongBox"
												}
											},
											"id": 2193,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "pass",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 2142,
											"src": "485:7:23",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
												"typeString": "function () view external returns (bool)"
											}
										},
										"id": 2194,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "485:9:23",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 2183,
									"id": 2195,
									"nodeType": "Return",
									"src": "478:16:23"
								}
							]
						},
						"documentation": null,
						"id": 2197,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2180,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2177,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 2197,
									"src": "350:17:23",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2176,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "350:7:23",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2179,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2197,
									"src": "369:15:23",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2178,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "369:7:23",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "349:36:23"
						},
						"payable": false,
						"returnParameters": {
							"id": 2183,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2182,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2197,
									"src": "410:4:23",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 2181,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "410:4:23",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "409:6:23"
						},
						"scope": 2198,
						"src": "324:175:23",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 2199,
				"src": "102:399:23"
			}
		],
		"src": "0:502:23"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/StrongBoxFactory.sol",
		"exportedSymbols": {
			"StrongBoxFactory": [
				2198
			]
		},
		"id": 2199,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2145,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:23"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 2146,
				"nodeType": "ImportDirective",
				"scope": 2199,
				"sourceUnit": 2867,
				"src": "26:26:23",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/StrongBox.sol",
				"file": "./StrongBox.sol",
				"id": 2147,
				"nodeType": "ImportDirective",
				"scope": 2199,
				"sourceUnit": 2144,
				"src": "53:25:23",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Guard.sol",
				"file": "./Guard.sol",
				"id": 2148,
				"nodeType": "ImportDirective",
				"scope": 2199,
				"sourceUnit": 1717,
				"src": "79:21:23",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 2149,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "131:5:23",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 2150,
						"nodeType": "InheritanceSpecifier",
						"src": "131:5:23"
					}
				],
				"contractDependencies": [
					1716,
					2143,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2198,
				"linearizedBaseContracts": [
					2198,
					2866,
					2922
				],
				"name": "StrongBoxFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 2174,
							"nodeType": "Block",
							"src": "215:105:23",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2157,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2152,
										"src": "221:7:23",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2158,
									"nodeType": "ExpressionStatement",
									"src": "221:7:23"
								},
								{
									"assignments": [
										2160
									],
									"declarations": [
										{
											"constant": false,
											"id": 2160,
											"name": "guard",
											"nodeType": "VariableDeclaration",
											"scope": 2175,
											"src": "234:11:23",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Guard_$1716",
												"typeString": "contract Guard"
											},
											"typeName": {
												"contractScope": null,
												"id": 2159,
												"name": "Guard",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1716,
												"src": "234:5:23",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Guard_$1716",
													"typeString": "contract Guard"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2164,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 2162,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "248:9:23",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$__$returns$_t_contract$_Guard_$1716_$",
												"typeString": "function () returns (contract Guard)"
											},
											"typeName": {
												"contractScope": null,
												"id": 2161,
												"name": "Guard",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1716,
												"src": "252:5:23",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Guard_$1716",
													"typeString": "contract Guard"
												}
											}
										},
										"id": 2163,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "248:11:23",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Guard_$1716",
											"typeString": "contract Guard"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "234:25:23"
								},
								{
									"assignments": [
										2166
									],
									"declarations": [
										{
											"constant": false,
											"id": 2166,
											"name": "sb",
											"nodeType": "VariableDeclaration",
											"scope": 2175,
											"src": "265:12:23",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_StrongBox_$2143",
												"typeString": "contract StrongBox"
											},
											"typeName": {
												"contractScope": null,
												"id": 2165,
												"name": "StrongBox",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2143,
												"src": "265:9:23",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_StrongBox_$2143",
													"typeString": "contract StrongBox"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2171,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2169,
												"name": "guard",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2160,
												"src": "294:5:23",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Guard_$1716",
													"typeString": "contract Guard"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_contract$_Guard_$1716",
													"typeString": "contract Guard"
												}
											],
											"id": 2168,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "280:13:23",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$_t_address_$returns$_t_contract$_StrongBox_$2143_$",
												"typeString": "function (address) returns (contract StrongBox)"
											},
											"typeName": {
												"contractScope": null,
												"id": 2167,
												"name": "StrongBox",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2143,
												"src": "284:9:23",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_StrongBox_$2143",
													"typeString": "contract StrongBox"
												}
											}
										},
										"id": 2170,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "280:20:23",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_StrongBox_$2143",
											"typeString": "contract StrongBox"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "265:35:23"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2172,
										"name": "sb",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2166,
										"src": "313:2:23",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_StrongBox_$2143",
											"typeString": "contract StrongBox"
										}
									},
									"functionReturnParameters": 2156,
									"id": 2173,
									"nodeType": "Return",
									"src": "306:9:23"
								}
							]
						},
						"documentation": null,
						"id": 2175,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2153,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2152,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2175,
									"src": "165:15:23",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2151,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "165:7:23",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "164:17:23"
						},
						"payable": true,
						"returnParameters": {
							"id": 2156,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2155,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2175,
									"src": "206:7:23",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2154,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "206:7:23",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "205:9:23"
						},
						"scope": 2198,
						"src": "141:179:23",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2196,
							"nodeType": "Block",
							"src": "418:81:23",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2184,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2179,
										"src": "424:7:23",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2185,
									"nodeType": "ExpressionStatement",
									"src": "424:7:23"
								},
								{
									"assignments": [
										2187
									],
									"declarations": [
										{
											"constant": false,
											"id": 2187,
											"name": "sb",
											"nodeType": "VariableDeclaration",
											"scope": 2197,
											"src": "437:12:23",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_StrongBox_$2143",
												"typeString": "contract StrongBox"
											},
											"typeName": {
												"contractScope": null,
												"id": 2186,
												"name": "StrongBox",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2143,
												"src": "437:9:23",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_StrongBox_$2143",
													"typeString": "contract StrongBox"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2191,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2189,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2177,
												"src": "462:9:23",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 2188,
											"name": "StrongBox",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2143,
											"src": "452:9:23",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_StrongBox_$2143_$",
												"typeString": "type(contract StrongBox)"
											}
										},
										"id": 2190,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "452:20:23",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_StrongBox_$2143",
											"typeString": "contract StrongBox"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "437:35:23"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"id": 2192,
												"name": "sb",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2187,
												"src": "485:2:23",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_StrongBox_$2143",
													"typeString": "contract StrongBox"
												}
											},
											"id": 2193,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "pass",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 2142,
											"src": "485:7:23",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
												"typeString": "function () view external returns (bool)"
											}
										},
										"id": 2194,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "485:9:23",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 2183,
									"id": 2195,
									"nodeType": "Return",
									"src": "478:16:23"
								}
							]
						},
						"documentation": null,
						"id": 2197,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2180,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2177,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 2197,
									"src": "350:17:23",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2176,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "350:7:23",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2179,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2197,
									"src": "369:15:23",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2178,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "369:7:23",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "349:36:23"
						},
						"payable": false,
						"returnParameters": {
							"id": 2183,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2182,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2197,
									"src": "410:4:23",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 2181,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "410:4:23",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "409:6:23"
						},
						"scope": 2198,
						"src": "324:175:23",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 2199,
				"src": "102:399:23"
			}
		],
		"src": "0:502:23"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.809Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/StrongBoxFactory.json
// module id = 1052
// module chunks = 0